import React from "react";
import Icon from "assets/icons";
import { useCopies } from "../../hooks/useCopies";
import { ReactComponent as AppStore } from "assets/img/appStore_badge.svg";
import { ReactComponent as PlayStore } from "assets/img/googlePlay_badge.svg";

function MobileAppLinks(props: { headerLogo?: string; appStoreLink?: string; playStoreLink?: string }) {
  const copies = useCopies();
  return (
    <React.Fragment>
      {props.headerLogo && (
        <div className="featureNotAvailable_header">
          <img alt="" src={props.headerLogo} />
        </div>
      )}
      <div className="featureNotAvailable_wrapper">
        <div className="featureNotAvailable_content">
          <Icon.NoMobileSupport />
          <p>{copies.get("feature.not.available.on.mobile")}</p>
        </div>
        {(props.appStoreLink || props.playStoreLink) && (
          <div className="featureNotAvailable_downloadMobileApp">
            <p>{copies.get("download.app.header")}</p>
            <div className="featureNotAvailable_downloadMobileApp_links">
              {props.appStoreLink && (
                <a title={copies.get("app.store")} href={props.appStoreLink}>
                  <AppStore />
                </a>
              )}
              {props.playStoreLink && (
                <a title={copies.get("play.store")} href={props.playStoreLink}>
                  <PlayStore />
                </a>
              )}
            </div>
          </div>
        )}
      </div>
    </React.Fragment>
  );
}

export default MobileAppLinks;
